import { ChevronDown } from "lucide-react";
import { useTheme } from "../../../context/ThemeProvider";
import UIStore from "../../../store/uiStore";
import { NewChatButton } from "./NewChatButton";
import { SidebarChatList } from "./SidebarChatList";

const SparkSection = () => {
  const { theme } = useTheme();
  const isCollapsed = UIStore((state) => state.sidebarCollapsed.spark);
  const toggleSection = UIStore((state) => state.toggleSidebarSection);
  const query = UIStore((state) => state.sidebarQuery);

  // While searching, force the section open so results are visible.
  const isOpen = !!query || !isCollapsed;

  const handleSectionClick = (e) => {
    // Prevent click from triggering when clicking on NewChatButton or its children
    if (e.target.closest('.new-spark-btn')) return;
  };
  return (
    <div className="flex flex-col h-full min-h-0" style={{ cursor: 'pointer' }} onClick={handleSectionClick}>
      <div className="flex-1 min-h-0 overflow-y-auto show-scrollbar-on-hover">
        <div className="new-spark-btn sticky top-0 z-10 bg-surface-sidebar flex items-center">
          <button
            type="button"
            onClick={() => toggleSection("spark")}
            className="pl-2 pr-1 text-ink-control-border dark:text-ink-white"
            aria-label={isCollapsed ? "Expand spark" : "Collapse spark"}
          >
            <ChevronDown
              className={`w-4 h-4 transition-transform duration-200 ${isCollapsed ? "-rotate-90" : ""}`}
            />
          </button>
          <div className="flex-1 min-w-0">
            <NewChatButton theme={theme} />
          </div>
        </div>
        {isOpen ? (
          <SidebarChatList theme={theme} searchQuery={query} scrollable={false} />
        ) : null}
      </div>
    </div>
  );
};

export default SparkSection;
